// session_state — the SHIM every consumer imports
// (plans/2026-07-14--session-detector-namespace-promotion.md).
//
// The detector's implementation lives in `lib/session_state_detector.js` and is imported by
// `packs/global.js` ALONE, which parks its two entry points on the Rankers namespace. This file
// forwards to them at CALL time, importing no heavy code — so it stays weightless in the four
// consumer bundles (nav, rankometer, member_offer_acceptor, account_panel) instead of inlining a
// ~1.4KB gz copy of the detector into each of them (esbuild runs `splitting: false` / IIFE, so
// there is no shared-chunk mechanism: whatever a pack imports, it inlines).
//
// It is the `announceSessionChange()` model, applied to the detector itself. Consumers and their
// jest mocks keep this exact import path — the move is invisible to them, which is the point.
//
// DELIBERATE ASYMMETRY WITH announceSessionChange(): that primitive NO-OPS when no detector is
// booted ("tell anyone who's listening" — nothing to do). These two do the opposite and THROW,
// because the caller is saying "I need to know who is logged in", and a silent no-op would strand
// the UI permanently logged-out with no error. Absence is a genuine bug, not a race:
// global.bundle.js is a plain blocking <script src> in <head> (no defer), so the namespace is
// always populated before any consumer runs.

export {SESSION_CHANGED_EVENT, SESSION_RECHECK_EVENT} from "../constants/session_events";

import {getRankersNamespace} from "../constants/rankers_namespace";

function sessionStateApi(name) {
  const fn = getRankersNamespace()[name];
  if (typeof fn !== "function") {
    throw new Error(
      `[session_state] Rankers_NS.${name} is missing — the global pack (global.bundle.js) has not ` +
      `run. It owns the one copy of the session detector; this module only forwards to it.`
    );
  }
  return fn;
}

export function observeSessionState(handler, options = {}) {
  return sessionStateApi("observeSessionState")(handler, options);
}

export function getSharedSessionStateDetector(options = {}) {
  return sessionStateApi("getSharedSessionStateDetector")(options);
}
